import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AfroTechConnectBannerService } from './afrotech-connect-banner.service';

@Component({
    selector: 'app-afrotech-connect-banner',
    templateUrl: './afrotech-connect-banner.component.html',
    styleUrls: ['./afrotech-connect-banner.component.scss']
})
export class AfroTechConnectBannerComponent implements OnInit {

	public data: any;

    constructor(
		private content: AfroTechConnectBannerService
    ) {
        this.content.getData().subscribe((data: any) => {
            this.data = data.data;
        });
    }

    ngOnInit(): void {}

    bannerEpisodesSlides: OwlOptions = {
		nav: true,
		loop: true,
		margin: 25,
		dots: false,
		autoplay: true,
		smartSpeed: 500,
		autoplayHoverPause: true,
		navText: [
			"<i class='ri-arrow-left-s-line'></i>",
			"<i class='ri-arrow-right-s-line'></i>"
		],
		responsive: {
			0: {
				items: 1
			},
			576: {
				items: 2
			},
			768: {
				items: 2
			},
			1024: {
				items: 3
			},
			1200: {
				items: 3
			}
		}
    }

}